import { DateFormat } from '@agroone/dates'

import { IsDateValidate } from '@agroone/helpers'
import { IsString } from 'class-validator'

export class UnplanifyOfferDto {
  @IsString()
  @IsDateValidate(DateFormat.YYYY_MM_DD)
  yesterdayDate!: string
}
